// just to be able to use bootstrap jQuery
window.$ = window.jQuery = require('jquery')

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'hamburgers/dist/hamburgers.css'

import '../stylus/global.styl'

$(document).ready(function () {
    $(window).scroll(function () {
        var bottom_of_window = $(window).scrollTop() + $(window).height();
        $('.hideme').each(function (i) {
            var bottom_of_object = $(this).offset().top;
            if (bottom_of_window > bottom_of_object) {
                $(this).animate({'opacity': '1'}, 2000);
            }
        });
    });
});